import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";

export default function CheckoutCancelled() {
  return (
    <PageShell testid="page-checkout-cancelled">
      <SEO title="Payment Cancelled" description="Your payment was cancelled. No charge was made." path="/checkout/cancelled" />
      <Nav />
      <section className="min-h-[70vh] flex items-center px-6 md:px-12 py-24">
        <div className="max-w-2xl mx-auto w-full border border-white/10 p-8 md:p-12" data-testid="checkout-cancelled-card">
          <div className="flex items-center gap-3 text-white/60">
            <XCircle size={22} />
            <span className="text-[11px] tracking-[0.32em] uppercase">Payment Cancelled</span>
          </div>
          <h1 className="mt-6 font-anton uppercase text-4xl md:text-5xl leading-[0.95]">
            No charge was made.
          </h1>
          <p className="mt-6 text-white/60 max-w-md">
            You cancelled the checkout before it completed. You can pick up where you left off any time.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/services" className="btn-primary inline-flex items-center gap-2 px-5 py-3 text-[11px] tracking-[0.24em] uppercase" data-testid="checkout-cancelled-back">
              Back to Services
            </Link>
            <Link to="/contact" className="btn-ghost inline-flex items-center gap-2 px-5 py-3 text-[11px] tracking-[0.24em] uppercase" data-testid="checkout-cancelled-help">
              Need Help?
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </PageShell>
  );
}
